// extracted by mini-css-extract-plugin
export default {"infoCard":"UploaderCard_infoCard__zW0pE"};